import { init } from '@rematch/core';
import createModel from './create-model';

const createStore = (initialState) => {
  return init({
    models: {
      mailToTarget: createModel(initialState)
    }
  });
};

export default createStore;
